import React from "react";
import Button from "@p1s/p1s-common-react/Button";
import LoginPageLinks from "../../utilities/LoginPageLinks";

const NewsletterSignUp = () => {
    return (<div className="newsletter-signup" id="newsletterSignUp">
        <div className="newsletter-text">
            Subscribe to receive newsletters with insights and resources created by our pharmacists, epidemiologists, IPs, physicians, and nurses.
        </div>
        <div className="newsletter-button">
            <Button id="signUp" className="btn" onClick={onSignUpClick}>Sign Up</Button>
        </div>
    </div>
    );
};

const onSignUpClick = () => {
    window.location = LoginPageLinks.SignUp;
};

export default NewsletterSignUp;
